import { render, staticRenderFns } from "./AddressRelations.vue?vue&type=template&id=b68fd1fe&scoped=true"
import script from "./AddressRelations.vue?vue&type=script&lang=js"
export * from "./AddressRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68fd1fe",
  null
  
)

export default component.exports